import { render, staticRenderFns } from "./com-tea.vue?vue&type=template&id=a97148ea&scoped=true&"
import script from "./com-tea.vue?vue&type=script&lang=js&"
export * from "./com-tea.vue?vue&type=script&lang=js&"
import style0 from "./com-tea.vue?vue&type=style&index=0&id=a97148ea&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97148ea",
  null
  
)

export default component.exports